<template>
  <div v-loading="loading">
    <div v-for="type in types" :key="type">
      <svg-icon icon-class="contract-agreement" />
      <el-tooltip class="item" effect="dark" :content="`Contract ${typeLabel(type)} Agreement`" placement="right">
        <p style="cursor:pointer;" @click="showList(type)">
          <el-tag :type="isOn(type) ? 'success' : 'danger'">
            Contract {{ typeLabel(type) }}: <b>{{ isOn(type) ? 'ON' : 'OFF' }}</b>
          </el-tag>
        </p>
      </el-tooltip>
    </div>

    <el-dialog :title="`Contract ${typeLabel(listType)} Agreement`" :visible.sync="dialogListVisible"
      width="800px" append-to-body>
      <el-table :data="runningContracts(listType)" border>
        <el-table-column prop="bankholderID" label="BankholderID" header-align="center" align="center" width="120">
        </el-table-column>
        <el-table-column prop="currency" label="Currency" header-align="center" align="center">
          <template slot-scope="scope">
            {{ scope.row.currency && scope.row.currency.toUpperCase() }}
          </template>
        </el-table-column>
        <el-table-column prop="status" label="Status" header-align="center" align="center">
          <template slot-scope="scope">
            <el-tag :type="scope.row.status === 'active' ? 'success' : 'warning'" size="small">
              {{ scope.row.status.toUpperCase() }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="Balance" header-align="center" align="right">
          <template slot-scope="scope">
            {{ balance(scope.row) }}
          </template>
        </el-table-column>
        <el-table-column prop="total_amount" label="Total" header-align="center" align="right">
          <template slot-scope="scope">
            {{ numberFormat(scope.row.total_amount) }}
          </template>
        </el-table-column>
        <el-table-column prop="duration_months" label="Months" header-align="center" align="center">
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import { getContractList } from "@/api/customer";
import { currencyFormat } from "@/utils";
export default {
  name: "ContractList",
  props: {
    customerUID: String
  },
  data() {
    return {
      loading: false,
      dialogListVisible: false,
      listType: "monthly",
      types: ["monthly", "compliance"],
      contracts: []
    }
  },
  methods: {
    typeLabel(type) {
      return type === 'monthly' ? 'Monthly' : 'Compliance';
    },
    numberFormat(value) {
      return currencyFormat(Number(value), '');
    },
    balance(item) {
      return item.last_state ? this.numberFormat(item.last_state.balance) : '-';
    },
    // active / suspended contracts only, completed ones are in contract history
    runningContracts(type) {
      return this.contracts.filter(item => item.type === type && (item.status === 'active' || item.status === 'suspended'));
    },
    // ON when any bank account has active contract of this type
    isOn(type) {
      return this.contracts.some(item => item.type === type && item.status === 'active');
    },
    showList(type) {
      this.listType = type;
      this.dialogListVisible = true;
    },
    reload() {
      this.loading = true;
      getContractList(this.customerUID).then(({ result, data }) => {
        this.loading = false;
        if (result && data) {
          this.contracts = data;
        }
      }).catch(() => {
        this.loading = false;
      });
    }
  },
  mounted() {
    this.reload();
  }
}
</script>

<style lang="scss" scoped></style>
